import { CARGO_TYPE } from '../../cargoType';
import useAgent from '../../hooks/useAgent';
import { getTransactions } from '../hooks/useGetTransactions';

const useGetBreakbulkTransactions = () =>
  useAgent((params) => {
    params.set('cargoType', CARGO_TYPE.breakbulk);
    return getTransactions(params);
  });

export default useGetBreakbulkTransactions;
